module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.2205ad24.svg";